// How to use (sections/how-to-use.liquid): moves the header blocks (everything that is not a Step card) above the card
// grid, numbers the cards for the reveal delay, and plays the videos without sound on a loop when "Play automatically"
// is on (otherwise they keep their controls).
(() => {
  if (window.themeHowToUse) return;
  window.themeHowToUse = true;

  const place = (htu) => {
    const header = htu.querySelector('[data-htu-header]');
    const grid = htu.querySelector('[data-htu-grid]');
    if (!header || !grid) return;
    [...grid.children].forEach((child) => { if (!child.matches('[data-htu-card]')) header.append(child); });
    grid.querySelectorAll(':scope > [data-htu-card]').forEach((card, i) => card.style.setProperty('--i', i));
    if (htu.dataset.autoplay !== 'true') return;
    htu.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.play().catch(() => { video.controls = true; });
    });
  };

  const all = (root = document) => root.querySelectorAll('.htu').forEach(place);
  all();
  document.addEventListener('shopify:section:load', (event) => all(event.target));
})();
